import PropTypes from 'prop-types';

import { CollapsingTooltip } from 'src/components/CollapsingTooltip';

import { useStyles } from './useStyles';

export const ProductDescriptionNode = ({ element, children, attributes }) => {
  const styles = useStyles();

  return (
    <CollapsingTooltip
      title={element.article}
      arrow
    >
      <span
        className={styles.root}
        {...attributes}
      >
        {children}
      </span>
    </CollapsingTooltip>
  );
};

ProductDescriptionNode.propTypes = {
  attributes: PropTypes.shape({}).isRequired,
  element: PropTypes.shape().isRequired,
  children: PropTypes.node,
  content: PropTypes.string,
};

ProductDescriptionNode.defaultProps = {
  children: null,
  content: null,
};
